<div class="pb-4 pl-4 pr-4 pt-2 decline">
  <div class="decline-icon" aria-hidden="true">
    <i class="bx bx-x-circle"></i>
  </div>

  <mat-dialog-content class="decline-content pb-3">
    <div class="decline-header">Decline request?</div>
    <p class="decline-body pt-3">
      <span class="text-black">{{ data.guestName }}</span> asked for {{ partyLabel }} at
      {{ data.when }}. The guest will be notified.
    </p>

    <label class="decline-label" for="declineReason">Reason for the guest (optional)</label>
    <textarea
      id="declineReason"
      class="decline-input"
      rows="3"
      [maxlength]="maxLength"
      placeholder="e.g. We're fully booked for a private event that evening."
      [(ngModel)]="reason"
      data-testid="decline-reason"
    ></textarea>
    <span class="decline-counter" aria-live="polite">{{ reason.length }}/{{ maxLength }}</span>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      type="button"
      mat-raised-button
      mat-dialog-close
      tabindex="-1"
      class="btn cancel-btn mr-3 bg-white text-black-50"
    >
      No, keep it
    </button>
    <button
      type="button"
      mat-raised-button
      class="btn confirm-btn text-white"
      (click)="decline()"
      data-testid="decline-confirm"
    >
      Yes, decline
    </button>
  </mat-dialog-actions>
</div>
